import { useAppConfig } from '@/shared/features/app-config/context/app-config-context';
import { TRbacConfig } from '@/shared/features/rbac/context/rbac-config-context.types';

export const useRbacConfig = (): TRbacConfig => useAppConfig().rbac;
